export default __webpack_public_path__ + "static/doodle-underline-2-p-955c960fa763c876347857707cbd5b9e.gif";